import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link, useLocation, useNavigate } from 'react-router-dom';
import api from './services/api';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Pipelines from './pages/Pipelines';
import Deployments from './pages/Deployments';

import Companies from './pages/Companies';
import CfApps from './pages/CfApps';
import AiAnalysis from './pages/AiAnalysis';
import CfHealthDashboard from './pages/CfHealthDashboard';
import GlobalChatBot from './components/GlobalChatBot';
import Login from './pages/Login';

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const links = [
    { path: '/', label: 'Dashboard', icon: '📊' },
    { path: '/companies', label: 'Companies', icon: '🏢' },
    { path: '/projects', label: 'Projects', icon: '📁' },
    { path: '/pipelines', label: 'Pipelines', icon: '🔄' },
    { path: '/deployments', label: 'Deployments', icon: '🚀' },
    { path: '/cf-apps', label: 'CF Apps', icon: '☁️' },
    { path: '/cf-health', label: 'CF Health', icon: '🏥' },
    { path: '/ai', label: 'AI Analysis', icon: '🤖' },
  ];

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <aside style={{
      width: 'var(--sidebar-width)', height: '100vh', position: 'fixed', left: 0, top: 0,
      background: 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)',
      color: '#fff', display: 'flex', flexDirection: 'column', zIndex: 100
    }}>
      <div style={{ padding: '20px 24px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ fontSize: 20, fontWeight: 700, letterSpacing: -0.5 }}>CLTS DevOps</div>
        <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>Center</div>
      </div>

      <nav style={{ flex: 1, padding: '12px' }}>
        {links.map(l => (
          <Link key={l.path} to={l.path} style={{
            display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px',
            borderRadius: 8, color: location.pathname === l.path ? '#fff' : '#94a3b8',
            background: location.pathname === l.path ? 'rgba(59,130,246,0.2)' : 'transparent',
            marginBottom: 4, fontSize: 14, fontWeight: 500, textDecoration: 'none',
            transition: 'all 0.15s'
          }}>
            <span style={{ fontSize: 18 }}>{l.icon}</span> {l.label}
          </Link>
        ))}
      </nav>

      <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ fontSize: 13, color: '#94a3b8' }}>{user.fullName || 'User'}</div>
        <div style={{ fontSize: 11, color: '#64748b' }}>{user.role}</div>
        <button onClick={logout} style={{
          marginTop: 8, width: '100%', padding: '6px 12px', background: 'rgba(255,255,255,0.1)',
          color: '#94a3b8', borderRadius: 6, fontSize: 12, border: 'none', cursor: 'pointer'
        }}>Logout</button>
      </div>
    </aside>
  );
}

function Layout({ children }) {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <main style={{ marginLeft: 'var(--sidebar-width)', flex: 1, padding: 24, minHeight: '100vh' }}>
        {children}
      </main>
      <GlobalChatBot />
    </div>
  );
}

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? <Layout>{children}</Layout> : <Navigate to="/login" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/companies" element={<ProtectedRoute><Companies /></ProtectedRoute>} />
        <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
        <Route path="/pipelines" element={<ProtectedRoute><Pipelines /></ProtectedRoute>} />
        <Route path="/deployments" element={<ProtectedRoute><Deployments /></ProtectedRoute>} />

        <Route path="/cf-apps" element={<ProtectedRoute><CfApps /></ProtectedRoute>} />
        <Route path="/cf-health" element={<ProtectedRoute><CfHealthDashboard /></ProtectedRoute>} />
        <Route path="/ai" element={<ProtectedRoute><AiAnalysis /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}
